export const listaColoresChart = [
    '#00A3E0', 
    '#8031A7', 
    '#B5BD00', 
    '#ed8b00', 
    '#09699c', 
    '#ffc000', 
    '#E0004D', 
    '#00C389', 
    '#707372', 
    '#bfbfbf',
    '#FF5733', // Naranja
    '#6E7E85', // Gris azulado
    '#AB2F52', // Rojo oscuro
    '#2E8B57', // Verde mar oscuro
    '#2A9AAD', // Azul violeta
    '#FFD700', // Oro
    '#4682B4', // Azul acero
    '#32CD32', // Verde lima
    '#8B4513', // Marrón oscuro
    '#FF1493', // Rosa profundo
    '#4B0082', // Índigo
    '#20B2AA', // Verde mar claro
    '#800000', // Rojo oscuro
    '#FFD700', // Amarillo dorado
    '#1E90FF', // Azul cielo
    '#808000', // Verde oliva
    '#8A2BE2', // Azul pizarra
    '#FF4500', // Naranja rojizo
    '#FF00FF', // Fucsia
  ];
  